var translatedHeadings = [
    {
        "value": "Home",
        "value-hindi": "होम"
    },
    {
        "value": "Ideals",
        "value-hindi": "आदर्श"
    },
    {
        "value": "Lineage",
        "value-hindi": "हमारे गुरु"
    },
    {
        "value": "Our Lineage",
        "value-hindi": "हमारे गुरु"
    },
    {
        "value": "Publications",
        "value-hindi": "प्रकाशन"
    },
    {
        "value": "Events",
        "value-hindi": "कार्यक्रम"
    },
    {
        "value": "Branches",
        "value-hindi": "शाखाएँ"
    },
    {
        "value": "Gallery",
        "value-hindi": "गैलरी"
    },
    {
        "value": "Main branch",
        "value-hindi": "मुख्य स्थान"
    },
    {
        "value": "Brahm Vidyalaya and Ashram, Chottka Rajpur, Buxar, Bihar.",
        "value-hindi": "ब्रह्म विद्यालय एवं आश्रम, छोटका राजपुर, बक्सर, बिहार।"
    },
    {
        "value":"Present Guru",
        "value-hindi": "वर्तमान गुरु"
    },
    {
        "value":"Prakatya diwas",
        "value-hindi": "प्राकट्य दिवस"
    },
    {
        "value":"Brahmleen diwas",
        "value-hindi": "ब्रह्मलीन दिवस"
    },
    {
        "value":"Select year",
        "value-hindi": "वर्ष चुनें"
    },
    {
        "value":"Select event",
        "value-hindi": "कार्यक्रम चुनें"
    },
    {
        "value":"Holi",
        "value-hindi": "होली"
    },
    {
        "value":"Bhandara",
        "value-hindi": "भंडारा"
    },
    {
        "value":"Guru Purnima",
        "value-hindi": "गुरु पूर्णिमा"
    },
    {
        "value":"Diwali",
        "value-hindi": "दीपावली"
    },
    {
        "value":"Ganga Dussehra",
        "value-hindi": "गंगा दशहरा"
    },
    {
        "value": "Shri Paramhans Dayal Smriti Pad Yatra",
        "value-hindi": "श्री परमहंस दयाल स्मृति पद यात्रा"
    },
    {
        "value":"Brahm Vidyalaya and Ashram, Chottka Rajpur, Buxar, Bihar.",
        "value-hindi": "ब्रह्म विद्यालय एवं आश्रम, छोटका राजपुर, बक्सर, बिहार।"
    },{
        "value":"Search for a branch...",
        "value-hindi": "शाखा खोजें..."
    }
];

const currentLanguageVal = localStorage.getItem("language");
const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";

export default function translatedHeading(heading){
    const translation = translatedHeadings.find(item => item.value === heading);
    if (translation) {
        return currentLanguage === "en" ? translation.value : translation["value-hindi"];
    }
    return heading; 
}